import React, { useRef } from "react";
import { Helmet } from "react-helmet";
import ApSummary from "./partials/AppointmentSummary";
import { appName } from "../../app.json";
import { Redirect, NavLink } from "react-router-dom";
import { UPDATE } from "../../queries/appointment.query";
import { useMutation } from "@apollo/react-hooks";
import LoadingSpinner from "../../partials/loading";
import { toast } from "react-toastify";
import { CleanMessage } from "../../util/app";
import { sendNotification } from "../../sockette";
import { ACTION_TYPE, EVENT_TARGET } from "../../event/model";

function Edit({ location }) {
    const { item } = location.state;

    // Local Reference
    const noteRef = useRef();
    setTimeout(() => {
        if (noteRef && noteRef.current) noteRef.current.value = item && item.note;
    }, 0);
    const title = "Update Appointment";

    const [createFunc, { loading }] = useMutation(UPDATE, {
        onError: (e) => toast.error(CleanMessage(e.message)),
        onCompleted: (d) => {
            const { message } = d.UpdateAppointment;
            toast.success(message);
            sendNotification(message, ACTION_TYPE.UPDATE, EVENT_TARGET.APPOINTMENT);
        },
    });
    // Check for item to update
    if (!item) {
        return (
            <Redirect
                to={{
                    pathname: "/home/appointment",
                }}
            />
        );
    }
    return (
        <>
            <Helmet>
                <title>
                    {title} | {appName}
                </title>

                <link href="../../main/formlayout.css" rel="stylesheet" type="text/css" />
            </Helmet>
            <div className="row">
                <ApSummary model={item} />
                <div className="col-md-8 col-xs-12">
                    <form
                        onSubmit={async (event) => {
                            event.preventDefault();
                            // update here
                            await createFunc({
                                variables: {
                                    id: item.id,
                                    note: noteRef.current.value,
                                    department: item.department.id,
                                },
                            });
                        }}
                    >
                        <div className="card">
                            <div className="card-head">
                                <header>
                                    <NavLink
                                        to={{
                                            pathname: "/home/appointment/list",
                                        }}
                                        title="Back"
                                        className="mdl-button mdl-button--icon margin-right-10 mdl-button--colored"
                                    >
                                        <i className="material-icons">keyboard_backspace</i>
                                    </NavLink>
                                    Update Appointment
                                </header>
                            </div>
                            <div className="card-body m-b-20">
                                <LoadingSpinner loading={loading} />
                                <div className="form-group">
                                    <label htmlFor="note-id">Appointment Note (if any)</label>
                                    <textarea name="note-id" id="note-id" ref={noteRef} className="form-control form-control-textarea" rows="6" placeholder="enter note"></textarea>
                                </div>
                                <div className="form-group text-center m-t-20">
                                    <button type="submit" className="mdl-button mdl-button--raised mdl-js-ripple-effect margin-right-10 m-t-20 btn-circle btn-success">
                                        Update Appointment
                                        <i className="material-icons">keyboard_arrow_up</i>
                                    </button>
                                    <NavLink
                                        to={{
                                            pathname: "/home/appointment/list",
                                        }}
                                        className="mdl-button mdl-button--raised mdl-js-ripple-effect m-t-20 btn-circle"
                                    >
                                        Cancel <i className="material-icons text-danger">close</i>
                                    </NavLink>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}

export default Edit;
